import styled from 'styled-components'
import { type SingleCTAData } from '@/features/cms/components/CMS/types'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { Column } from '@shipt/design-system-layouts'
import { CMSErrorHandler } from '@/features/cms/components/CMS/CMSErrorHandler'
import { useCMSTrackingEvents } from '@/features/cms/components/CMS/CMSContext'
import { ButtonLink } from '@/features/shared/elements/Link/Buttons'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'

/**
 * This component corresponds to the `single_cta` content type in the CMS.
 *
 * - **Staging** - https://cms-staging.shipt.com/content-type/pool/single_cta
 * - **Production** - https://cms.shipt.com/content-type/pool/single_cta
 */
export const SingleCTA = ({ content_type_id, id, data: { cta_text, concept } }: SingleCTAData) => {
  const { trackCMSElementClicked } = useCMSTrackingEvents()
  const handleButtonClick = () => {
    trackCMSElementClicked({
      content: cta_text.text,
      type: 'button',
    })
  }

  try {
    return (
      <GridLayoutContainer {...getCMSWrapperProps({ content_type_id, id })}>
        <ContentWrapper spacing="xl" align="center">
          <ButtonLink
            size="lg"
            href={cta_text.url}
            onClick={handleButtonClick}
            concept={concept ?? 'accent'}
            opensInNewTab={cta_text.open_in_new_tab}
          >
            {cta_text.text}
          </ButtonLink>
        </ContentWrapper>
      </GridLayoutContainer>
    )
  } catch (error) {
    return <CMSErrorHandler error={error} contentTypeId={content_type_id} id={id} />
  }
}

const ContentWrapper = styled(Column)`
  width: 100%;
  height: fit-content;
`
